// removed by extract-text-webpack-plugin
module.exports = {"block":"DmcaFooter_block_1pXh8","content":"DmcaFooter_content_2ccBt","copyright":"DmcaFooter_copyright_2e07j"};